import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import OverflowMenuIcon from './OverFlowMenuIcon';
import TransitionForm from '../TransitionForm';

export default function AddAsset ({ stage, configFile }) {
  const [form, setForm] = useState(false);
  const [showAddAsset, setShowAddAsset] = useState(false);
  const [userRol, setUserRol] = useState('');
  const [formProps, setFormProps] = useState({});

  useEffect(() => {
    async function getUserRol () {
      await Auth.currentSession()
        .then(data => setUserRol(data.idToken.payload.role))
        .catch(err => {
          console.error(err);
          setUserRol('');
        });
    }
    getUserRol();
    parserAddAsset(stage);
  });

  function parseForm (transition) {
    if (transition) {
      const props = {
        actions: transition.actions,
        origin: { stage: transition.source },
        destination: transition.destination,
        transitionName: transition.nombre,
        configId: configFile.configId,
        stages: configFile.stages.map(stage => stage.stages).flat()
      };
      setFormProps(props);
      setForm(true);
    }
  }

  async function parserAddAsset (stage) {
    return await new Promise((resolve, reject) => {
      configFile.transitions.forEach(transition => {
        if (transition.roles.includes(userRol)) {
          stage.stages.forEach(value => {
            if (transition.destination === value.id && transition.source === 'none') {
              resolve(setShowAddAsset(true));
            }
          });
        }
      });
    });
  }

  return (
    <>
      {showAddAsset &&
        <OverflowMenuIcon stage={stage} parseForm={parseForm} configFile={configFile} userRol={userRol} />}
      {form && <TransitionForm {...formProps} setForm={setForm} />}
    </>
  );
}
